// Conversation Channels - must match the backend enum values
export const ConversationChannel = {
  WHATSAPP_TWILIO: 'whatsapp_twilio',
  WHATSAPP_WABA: 'whatsapp_waba',
  SMS: 'sms',
  EMAIL: 'email',
  VOICE: 'voice',
  WEBCHAT: 'webchat'
};

// Template Types - must match the backend enum values
export const NexiGlobalTemplateType = {
  INTERNAL: 'internal',
  WHATSAPP_TEMPLATE: 'whatsapp_template',
  WHATSAPP_QUICK_REPLY: 'whatsapp_quick_reply',
  AGENT_TOOL_REPLY: 'agent_tool_reply'
};

// Language Codes - must match the backend enum values
export const LanguageCode = {
  EN_US: 'en_US',
  ZH_HK: 'zh_HK',
  ZH_CN: 'zh_CN'
};
